import { List, Map } from "immutable";

export const getEntity = (state) => state.entity;

export const getEntityId = (state) => getEntity(state).get("id");
export const getLocale = (state) => getEntity(state).get("default_locale");

export const getEntityName = (state) => getEntity(state).get("name");

export const getAppeals = (state) => getEntity(state).get("appeals");

export const getCampaignCategories = (state) =>
  getEntity(state).get("campaign_categories");

export const getEnabledFeatures = (state) => getEntity(state).get("features_enabled");

export const getEntityMicrositeCampaign = (state) =>
  getEntity(state).get("microsite_campaign") || new Map();

export const getEntityMicrositeCampaignId = (state) =>
  getEntityMicrositeCampaign(state).get("id");

export const getRequireDonationAddress = (state) =>
  getEntity(state).get("donation_address_required");

export const getRequireDonationPhoneNumber = (state) =>
  getEntity(state).get("donation_phone_number_required");

export const getRequiredMinimumDonationAmount = (state) =>
  getEntity(state).get("minimum_giving_day_amount");

export const getSelectCategoryCopy = (state) =>
  getEntity(state).get("select_category_copy") || "Select a Category";

export const getCurrencySymbol = (state) => getEntity(state).get("currency_symbol");

export const getCurrencyCode = (state) => getEntity(state).get("currency_code") || "USD";

export const getLanguage = (state) => getEntity(state).get("language");

export const getFlatFee = (state) => getEntity(state).get("processing_flat_fee");

export const getPercentFee = (state) => getEntity(state).get("processing_percent");
